import { Types } from "@grandvisionhq/graphql";
import { getLocalizedString } from "@grandvisionhq/utils";
import { toBaseLineItem } from "./base-line-item.js";
const isBundledContactLensesLineItem = (bundledLineItem) => {
  return "prescription" in bundledLineItem;
};
const isBundledSolutionLineItem = (bundledLineItem) => {
  return "volume" in bundledLineItem.product;
};
const toContactLensesBundleOrderLineItem = (orderLineItem, intl, options = {}) => {
  const base = toBaseLineItem(orderLineItem, intl, options);
  const bundledSolutionLineItem = orderLineItem.bundledLineItems?.find(isBundledSolutionLineItem);
  const contactLensesProducts = orderLineItem.bundledLineItems?.filter(
    isBundledContactLensesLineItem
  );
  const leftContactLensesProduct = contactLensesProducts?.find(
    (item) => item.eyeSide === Types.EyeSide.LEFT || item.eyeSide === Types.EyeSide.BOTH
  );
  const rightContactLensesProduct = contactLensesProducts?.find(
    (item) => item.eyeSide === Types.EyeSide.RIGHT || item.eyeSide === Types.EyeSide.BOTH
  );
  let prescription = void 0;
  if (rightContactLensesProduct?.prescription) {
    const { __typename, ...rightPrescription } = rightContactLensesProduct.prescription;
    prescription = prescription || {};
    prescription.rightEye = { ...rightPrescription };
  }
  if (leftContactLensesProduct?.prescription) {
    const { __typename, ...leftPrescription } = leftContactLensesProduct.prescription;
    prescription = prescription || {};
    prescription.leftEye = { ...leftPrescription };
  }
  return {
    ...base,
    type: "CONTACT_LENS_BUNDLE",
    productType: "contact-lenses-bundle-benelux",
    prescription,
    bundleChildLineItems: bundledSolutionLineItem ? [
      {
        title: intl.getLabel("facets.productType.solutions"),
        body: getLocalizedString(bundledSolutionLineItem.product.name, intl.locale),
        price: bundledSolutionLineItem.price.totalPaid ?? 0,
        originalPrice: bundledSolutionLineItem.price.productPrice === bundledSolutionLineItem.price.totalPaid ? void 0 : bundledSolutionLineItem.price.productPrice ?? 0
      }
    ] : void 0
  };
};
export {
  toContactLensesBundleOrderLineItem
};
//# sourceMappingURL=contact-lenses-bundle-line-item.js.map
